import { SettingsService } from './socket-settings';

export interface ApiSettings {
    getCallCenterInfo(): Promise<any>;
    getServerTime(): Promise<Date>;
    isTeamsCustomerJourneyEnabled(): Promise<boolean>;
}

export const socketSettings = new SettingsService();